export const ar = {
	home: "الصفحه الرئيسيه",
	products: "المنتجات",
	categories: "الأقسام",
	"about-us": "من نحن",
	quick_links: "روابط سريعة",
	"Shop By Category": "تسوق حسب القسم",
	"View All": "عرض الكل",
	"Explore All": "استكشاف الكل",
	Explore: "استكشف",
	"Feature Products": "المنتجات المميزة",
	QUALITY: "الجودة التي يقدمها لك MASTER HN",
	"Best Selling Products": "أفضل المنتجات مبيعا",
	"Best Selling": "الأفضل مبيعا",
	"DOWNLOAD MASTER HN": "تحميل Master HN",
	"Style Up Your Looks": "صمم مطبخك",
	"Privacy Policy": "سياسة الخصوصية",
	"Terms & Condition": "الشروط والأحكام",
	"All Rights": "كل الحقوق محفوظة",
	"Hasan Al Naser": "حسن الناصر",
	"Powered By": "مدعوم من",
	"Total Price": "السعر الإجمالي",
	Continue: "متابعة",
	"Your Cart is Empty": "عربة التسوق فارغة",
	KWD: "د.ك",
	"Download Pdf": "تحميل الملف",
	"Style Up": "صمم",
	"Add To Cart": "أضف إلى السلة",
	contact: "اتصل بنا",
	Name: "الإسم",
	Email: "البريد الإلكتروني",
	Phone: "رقم الموبايل",
	Message: "الرسالة",
	Design: "تصميم",
	"CONTACT US ON WHATSAPP": "تواصل معنا عبر واتساب",
	"Contact Us": "تواصل معنا",
	"Know more about Us": "تعرف علينا أكثر",
	"GET IN TOUCH": "ابق على تواصل",
	Product: "المنتج",
	Price: "السعر",
	Quantity: "الكمية",
	Total: "الإجمالي",
	"Sub Total": "المجموع الفرعي",
	Payment: "الدفع",
	"Cancel Order": "إلغاء الطلب",
	"Cancel Message":
		"يرجى ملاحظة أن هذا الإجراء لا يمكن التراجع عنه وسيتم إلغاء الطلب",
	Close: "إغلاق",
	Done: "تم",
	"Payment Details": "تفاصيل الدفع",
	Proceed: "هل ترغب في المتابعة لإتمام الطلب كـ",
	Login: "تسجيل الدخول",
	"Continue as a Guest": "المتابعة كزائر",
	"Login Into Your Account": "تسجيل الدخول إلى حسابك",
	"Create New Account": "إنشاء حساب جديد",
	Password: "الرقم السري",
	"Don't Have Account": "ليس لديك حساب",
	"Sign Up": "التسجيل",
	"Have Account": "لديك حساب",
	Checkout: "إتمام الشراء",
	"No Orders": "لا يوجد طلبات",
	"User Details": "تفاصيل المستخدم",
	"Full Name": "الاسم الكامل",
	"Address Details": "تفاصيل العنوان",
	Details: "تفاصيل",
	Address: "العنوان",
	Area: "المنطقة",
	Block: "البلوك",
	view: "عرض",
	Street: "الشارع",
	Avenue: "الجادة",
	"Floor Number": "رقم الطابق",
	status: "الحالة",
	"Order Date": "تاريخ الطلب",
	"Order ID": "الطلب ID",
	Optional: "اختياري",
	"Address Type": "نوع العنوان",
	"Building Number": "رقم المبنى",
	Floor: "الطابق",
	"Apartment Number": "رقم الشقة",
	"House Number": "رقم المنزل",
	"Office Number": "رقم المكتب",
	"Extra Directions": "اتجاهات إضافية",
	"Other Instructions": "تعليمات أخرى",
	"Please Enter": "الرجاء إدخال",
	"Please Select": "الرجاء التحديد",
	House: "المنزل",
	Flat: "شقه",
	Office: "المكتب",
	"Coupon Code": "رمز الكوبون",
	Apply: "تطبيق",
	"Payment Method": "طريقة الدفع",
	KNET: "كي نت",
	"Visa/MasterCard": "فيزا/ماستركارد",
	"Payment Detail": "تفاصيل الدفع",
	Discount: "الخصم",
	"Delivery Charges": "رسوم التوصيل",
	"Submit Order": "ارسال الطلب",
	"show some love to your bag": "أظهر بعض الحب لحقيبتك",
	"Fill your bag with things that make you happy":
		"املأ حقيبتك بالأشياء التي تسعدك",
	Profile: "الصفحه الشخصيه",
	Logout: "تسجيل الخروج",
	"My Account": "حسابي",
	"My Orders": "طلباتي",
	"Update Account": "تحديث الحساب",
	Update: "تحديث",
	"Change Password": "تغيير كلمة المرور",
	"New Password": "كلمة المرور الجديدة",
	"Old Password": "كلمة المرور القديمه",
	"Confirm New Password": "تأكيد كلمة المرور الجديدة",
	"This Field is required": "هذه الخانة مطلوبه",
	Amount: "كميه",
	"ordered successfully": "شكرًا لك على طلبك",
	"ordered successfully description": "تم تقديم طلبك بنجاح",
	"ordered failed": "حدث خطأ ما!",
	"ordered failed description": "لم يتم استكمال الدفع",
	Cancel: "إلغاء",
	"Cash in Delivery": "نقدا عند التسليم",
	canceled: "تم الإلغاء",
	"out of stock": "نفذ من المخزن",
	"try again": "حاول مرة أخرى",
	ordered: "تم الطلب",
	process: "قيد التنفيذ",
	shipped: "تم الشحن",
	delivered: "تم التسليم",
	Add: "إضافة",
	"Buy it again": "اشتري مره أخري",
	"Add Address First": "اضف العنوان اولا",
	"There are No Products": "لا يوجد منتجات",
	"Product Added To Cart": "تم إضافة المنتج إلى سلة التسوق",
	"Forget Password?": "هل نسيت كلمه المرور؟",
	Default: "الافتراضية",
	"Forget Password": "نسيت كلمه المرور",
	Back: "الي الخلف",
	Delete: "حذف",
	"Address Added Successfully.": "تمت إضافة العنوان بنجاح.",
	"Address Updated Successfully.": "تمت تعديل العنوان بنجاح.",
	"Address Deleted Successfully.": "تمت حذف العنوان بنجاح.",
	"Message Sent Successfully.": "تم إرسال الرسالة بنجاح.",
	"First Name": "الاسم الأول",
	"Last Name": "اسم العائلة",
	"Message Required": "الرسالة المطلوبة",
	"promo code is invalid!": "الرمز الترويجي غير صالح!",
	"Successfully Applied": "تم التطبيق بنجاح",
	"Remove from Cart": "إزالة من السلة",
	Remove: "إزاله",
	Search: "بحث",
	"Classic kitchen": "مطبخ كلاسيكي",
	"Modern kitchen": "المطبخ الحديث",
	"No Address": "لا يوجد عنوان",
	"Add New Address": "إضافة عنوان جديد",
	"Set Default": "تعيين كافتراضي",
	Edit: "تعديل",
	"Send Request Design": "إرسال طلب تصميم",
	"Great Designs Await!": "",
	Designs: "",
	"Explore the latest opportunities and submit your price offer today.":
		"Explore the latest opportunities and submit your price offer today.",
	All: "الكل",
	Modern: "حديث",
	Classic: "كلاسيكي",
	Open: "مفتوح",
};
